import { Pipe , PipeTransform } from '@angular/core'
import { OrgBrowserView } from '../../models/org-browser-view'

@Pipe({ name: "orgSortBy" })
export class OrgSortByPipe implements PipeTransform {
    transform(array: Array<OrgBrowserView>, args: string): Array<OrgBrowserView> {
        array.sort((a: any, b: any) => {
            if (a[args] < b[args]) {
                return -1;
            } else if (a[args] > b[args]) {
                return 1;
            } else {
                return 0;
            }
        });
        return array;
    }
}